import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getBeneficiaries, getList } from '../../API/apiService';
import BreadCrumb from '../../components/breadCrumb';
import DownloadBeneficiaries from '../../components/downloadBeneficiaries';
import UserItem from '../../components/adminSchools/userItem';
import './style.scss';

function UserListAdmin() {
  const [searchParams] = useSearchParams();
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [genders, setGenders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const querys = Object.fromEntries(searchParams.entries());
  const schoolLabel = querys?.escuela?.toUpperCase?.() || '';
  const groupLabel = querys?.group?.toUpperCase?.() || '';
  const groupId = querys?.groupId;
  const safeGroupCode = (groupLabel || 'grupo').replace(/[^a-zA-Z0-9_-]+/g, '_');
  const fileName = `caracterizacion${safeGroupCode}.xlsx`;

  useEffect(() => {
    let isMounted = true;

    async function loadGenders() {
      const list = await getList('gender');
      if (isMounted) {
        setGenders(Array.isArray(list) ? list : []);
      }
    }

    loadGenders();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    async function loadBeneficiaries() {
      if (!groupId) {
        if (isMounted) {
          setBeneficiaries([]);
          setIsLoading(false);
        }
        return;
      }

      setIsLoading(true);
      const list = await getBeneficiaries(groupId);

      if (!isMounted) return;

      setBeneficiaries(Array.isArray(list) ? list : []);
      setIsLoading(false);
    }

    loadBeneficiaries();

    return () => {
      isMounted = false;
    };
  }, [groupId]);

  return (
    <section className='usersTable-main-container'>
      <BreadCrumb />
      <section className='usersTable-container'>
        <div className='table-top'>
          <div className='table-heading'>
            <div className='title-block'>
              <p className='title'>
                LISTA DE BENEFICIARIOS INSCRITOS {schoolLabel} <span> - </span>
                {groupLabel}
              </p>
              <p className='pagination-text'>
                Mostrando <span>{beneficiaries.length}</span> beneficiarios
              </p>
            </div>
            <DownloadBeneficiaries
              beneficiaries={beneficiaries}
              genders={genders}
              buttonText='Descargar caracterización'
              buttonIcon='download'
              fileName={fileName}
              containerClassName='users-download'
              buttonClassName='download-btn users-download__button'
              disabled={isLoading || beneficiaries.length === 0}
            />
          </div>
        </div>
        <div className='users-container'>
          {isLoading ? (
            <p className='empty-state'>Cargando beneficiarios...</p>
          ) : beneficiaries.length > 0 ? (
            <UserItem beneficiaries={beneficiaries} />
          ) : (
            <p className='empty-state'>
              No hay beneficiarios registrados para este grupo.
            </p>
          )}
        </div>
      </section>
    </section>
  );
}

export default UserListAdmin;
